import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NotasFaturamentoService {

  readonly serviceApi = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  requestNotasFaturamento(empresaId: number, dataDe: string, dataPara: string) {
    return this.http.get(
      `${this.serviceApi}/v1/dominio-reports/notas-faturamento-report?empresaId=${empresaId}&dataDe=${dataDe}&dataPara=${dataPara}`
    );
  }
}
